import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  HiChevronRight,
  HiArrowNarrowRight,
} from "react-icons/hi";

import {
  HiOutlineGlobeAmericas,
  HiOutlineSignal,
} from "react-icons/hi2";

import {
  IoLeafOutline,
  IoThermometerOutline,
  IoSnowOutline,
  IoMapOutline
} from "react-icons/io5";

import Image from "../../images/contributor-homepage.webp";
import MartinBergman from "../../images/Martin_Bergmanb.2e16d0ba.fill-1800x1012.webp";
import UngavaBay3 from "../../images/Ungava Bay-3.webp";
import UngavaBay17 from "../../images/Ungava Bay-17.webp";
import UngavaBay11 from "../../images/Ungava Bay-11.webp";
import LogoNWT from "../../images/partners/NWT.png";
import LogoQueens from "../../images/partners/Queens.png";
import LogoUofBC from "../../images/partners/UofBC.png";
import LogoUofCalgary from "../../images/partners/UofCalgary.png";
import LogoUofM from "../../images/partners/UofM.png";
import LogoUofDalhousie from "../../images/partners/UofDalhousie.png";
import LogoUofNB from "../../images/partners/UofNB.png";
import LogoUofVictoria from "../../images/partners/UofVictoria.png";
import { getUserSession } from "../../Common/lib/Session";

/**
 * Returns the Main page component.
 *
 * @returns The Main page component.
 */
const Main = () => {
  let history = useHistory();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    let cancelled = false;

    getUserSession()
      .then((session) => {
        if (!cancelled) {
          setIsLoggedIn(!!session?.success);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIsLoggedIn(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const contributorCtaTarget = isLoggedIn ? "/submit-data" : "/signup";
  const contributorCtaLabel = isLoggedIn ? "Submit Data" : "Create Account";

  /**
   * SVG element consisting of 25 circles. Used for styling.
   * @param {*} style Tailwind CSS styles to be used
   * @returns svg element
   */
  function candyBox(style) {
    return (
      <svg className={style} viewBox="0 0 184 184" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.55556" cy="7.55556" r="7.55556" fill="#F4F4F4" />
        <circle cx="7.55556" cy="49.7777" r="7.55556" fill="#F4F4F4" />
        <circle cx="7.55556" cy="92" r="7.55556" fill="#F4F4F4" />
        <circle cx="7.55556" cy="134.222" r="7.55556" fill="#F4F4F4" />
        <circle cx="7.55556" cy="176.444" r="7.55556" fill="#F4F4F4" />
        <circle cx="49.7777" cy="7.55556" r="7.55556" fill="#F4F4F4" />
        <circle cx="49.7777" cy="49.7777" r="7.55556" fill="#F4F4F4" />
        <circle cx="49.7777" cy="92" r="7.55556" fill="#F4F4F4" />
        <circle cx="49.7777" cy="134.222" r="7.55556" fill="#F4F4F4" />
        <circle cx="49.7777" cy="176.444" r="7.55556" fill="#F4F4F4" />
        <circle cx="91.9999" cy="7.55556" r="7.55556" fill="#F4F4F4" />
        <circle cx="91.9999" cy="49.7777" r="7.55556" fill="#F4F4F4" />
        <circle cx="91.9999" cy="92" r="7.55556" fill="#F4F4F4" />
        <circle cx="91.9999" cy="134.222" r="7.55556" fill="#F4F4F4" />
        <circle cx="91.9999" cy="176.444" r="7.55556" fill="#F4F4F4" />
        <circle cx="134.222" cy="7.55556" r="7.55556" fill="#F4F4F4" />
        <circle cx="134.222" cy="49.7777" r="7.55556" fill="#F4F4F4" />
        <circle cx="134.222" cy="92" r="7.55556" fill="#F4F4F4" />
        <circle cx="134.222" cy="134.222" r="7.55556" fill="#F4F4F4" />
        <circle cx="134.222" cy="176.444" r="7.55556" fill="#F4F4F4" />
        <circle cx="176.444" cy="7.55556" r="7.55556" fill="#F4F4F4" />
        <circle cx="176.444" cy="49.7777" r="7.55556" fill="#F4F4F4" />
        <circle cx="176.444" cy="92" r="7.55556" fill="#F4F4F4" />
        <circle cx="176.444" cy="134.222" r="7.55556" fill="#F4F4F4" />
        <circle cx="176.444" cy="176.444" r="7.55556" fill="#F4F4F4" />
      </svg>
    );
  }

  const contributeRef = useRef(null)

  return (
    <>
      <main className="bg-white dark:bg-gray-900">
        {/* Landing secton */}
        <section className="bg-white relative isolate overflow-hidden dark:bg-gray-900">
          <div
            className="absolute left-[calc(50%-4rem)] top-10 -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)]"
            aria-hidden="true"
          >
            <div
              className=" aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-blue-800 to-blue-600 opacity-20"
              style={{
                clipPath:
                  "polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 48.9% 0.2%, 73.6% 51.7%)",
              }}
            />
          </div>

          <div className="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-10 lg:px-6">
            <div className="text-gray-500 dark:text-gray-400">
              <p className="mb-2">
                <b style={{ color: "red" }}>Notice:</b> This site is currently
                under development. During this period, you may experience data
                loss, downtime, loss of service, and other errors. We apologize
                for any inconvenience and appreciate your understanding as we
                work to improve the site. Thank you for your patience.
              </p>

              <div className="mb-2">
                <div
                  href=""
                  className="inline-flex space-x-6 cursor-pointer"
                  onClick={() => contributeRef.current.scrollIntoView()}
                >
                  <span className="inline-flex items-center rounded-full px-3 py-1 text-sm font-semibold leading-6 text-blue-500 ring-1 ring-inset ring-blue-500">
                    See how you can contribute to our database
                    <HiChevronRight
                      className="h-5 w-5 text-blue-500"
                      aria-hidden="true"
                    />
                  </span>
                </div>
              </div>

              <h1 className="mb-8 text-7xl sm:text-8xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                Arctic <br />
                Research <br />
                Database
              </h1>
              <p className="mb-8 text-gray-500 leading-8 text-lg dark:text-gray-400">
                We bring together a collection of valuable data, from wildlife
                to environmental conditions and Indigenous knowledge, empowering
                researchers and the public to explore and understand the Arctic
                like never before.
              </p>
              <button
                type="button"
                className="inline-flex items-center gap-x-2 rounded-md bg-blue-700 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                onClick={(e) => history.push("/data-catalogue")}
              >
                Explore Data Catalogue
              </button>
              <button
                type="button"
                className="ml-4 inline-flex items-center gap-x-2 rounded-md border-2 border-blue-700 px-5 py-3 text-sm font-semibold text-blue-700 shadow-sm hover:text-white hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:text-white dark:border-blue-700"
                onClick={(e) => history.push("/about")}
              >
                About Us
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 lg:mt-0 mt-10">
              {candyBox("w-24 h-24 absolute -ml-10 mt-10 hidden lg:block")}
              {candyBox(
                "w-24 h-24 absolute -mr-10 -mb-10 hidden lg:block justify-self-end self-end"
              )}

              <img
                className="w-full rounded-lg object-cover h-80"
                src={MartinBergman}
                alt="Martin Bergmann research vessel"
                draggable="false"
              />
              <img
                className="mt-4 w-full lg:mt-10 h-64 object-cover rounded-lg"
                src={UngavaBay3}
                alt="Researchers handling equipment on research vessel"
                draggable="false"
              />
              <img
                className="w-full h-64 object-cover rounded-lg hidden lg:block"
                src={UngavaBay17}
                alt="Researcher handling equipment on research vessel"
                draggable="false"
              />
              <img
                className="-mt-6 w-full h-80 object-cover rounded-lg hidden lg:block"
                src={UngavaBay11}
                alt="William Kennedy research vessel"
                draggable="false"
              />
            </div>
          </div>
        </section>

        {/* Chips section */}
        <section className="mt-32 bg-gray-50 dark:bg-gray-800">
          <div className="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
            <div className="dark:text-gray-400">
              <h2 className="mb-4 text-4xl text-center tracking-tight font-bold text-gray-900 dark:text-white">
                Explore Datasets By Keyword
              </h2>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 mt-8">
              <div
                className="border border-gray-100 group hover:bg-blue-500 bg-white justify-center p-6 rounded-lg shadow cursor-pointer dark:bg-gray-900 dark:border-gray-700"
                onClick={() =>
                  history.push("/data-catalogue?keywords=Climate+change")
                }
              >
                <HiOutlineGlobeAmericas
                  className="group-hover:text-white w-full text-blue-500 h-20"
                  aria-hidden="true"
                />
                <p className="text-center group-hover:text-white mt-2 text-gray-900 font-semibold text-lg dark:text-gray-200">
                  Climate Change
                </p>
              </div>
              <div
                className="border border-gray-100 group hover:bg-blue-500 bg-white justify-center p-6 rounded-lg shadow cursor-pointer dark:bg-gray-900 dark:border-gray-700"
                onClick={() => history.push("/data-catalogue?keywords=Mapping")}
              >
                <IoMapOutline
                  className="group-hover:text-white w-full text-blue-500 h-20"
                  aria-hidden="true"
                />
                <p className="text-center group-hover:text-white mt-2 text-gray-900 font-semibold text-lg dark:text-gray-200">
                  Mapping
                </p>
              </div>
              <div
                className="border border-gray-100 group hover:bg-blue-500 bg-white justify-center p-6 rounded-lg shadow cursor-pointer dark:bg-gray-900 dark:border-gray-700"
                onClick={() =>
                  history.push("/data-catalogue?keywords=Bathymetry")
                }
              >
                <HiOutlineSignal
                  className="group-hover:text-white w-full text-blue-500 h-20"
                  aria-hidden="true"
                />
                <p className="text-center group-hover:text-white mt-2 text-gray-900 font-semibold text-lg dark:text-gray-200">
                  Bathymetry
                </p>
              </div>
              <div
                className="border border-gray-100 group hover:bg-blue-500 bg-white justify-center p-6 rounded-lg shadow cursor-pointer dark:bg-gray-900 dark:border-gray-700"
                onClick={() =>
                  history.push("/data-catalogue?keywords=Vegetation")
                }
              >
                <IoLeafOutline
                  className="group-hover:text-white w-full text-blue-500 h-20"
                  aria-hidden="true"
                />
                <p className="text-center group-hover:text-white mt-2 text-gray-900 font-semibold text-lg dark:text-gray-200">
                  Vegetation
                </p>
              </div>
              <div
                className="border border-gray-100 group hover:bg-blue-500 bg-white justify-center p-6 rounded-lg shadow cursor-pointer dark:bg-gray-900 dark:border-gray-700"
                onClick={() =>
                  history.push("/data-catalogue?keywords=Temperature")
                }
              >
                <IoThermometerOutline
                  className="group-hover:text-white w-full text-blue-500 h-20"
                  aria-hidden="true"
                />
                <p className="text-center group-hover:text-white mt-2 text-gray-900 font-semibold text-lg dark:text-gray-200">
                  Temperature
                </p>
              </div>
              <div
                className="border border-gray-100 group hover:bg-blue-500 bg-white justify-center p-6 rounded-lg shadow cursor-pointer dark:bg-gray-900 dark:border-gray-700"
                onClick={() =>
                  history.push("/data-catalogue?keywords=Cambridge+Bay")
                }
              >
                <IoSnowOutline
                  className="group-hover:text-white w-full text-blue-500 h-20"
                  aria-hidden="true"
                />
                <p className="text-center group-hover:text-white mt-2 text-gray-900 font-semibold text-lg dark:text-gray-200">
                  Cambridge Bay
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Image section */}
        {/* <div className="mt-32 xl:mx-auto xl:max-w-7xl xl:px-8">
        <img
        src={HeadImg}
        alt=""
        className="aspect-[5/2] w-full object-cover xl:rounded-3xl"
        />
      </div> */}

        {/* Partners section */}
        <section className="mt-32 overflow-hidden">
          <div className="py-8 lg:py-10 grid-cols-1 grid relative mx-auto max-w-screen-xl px-4">
            {" "}
            {/* Has to be a relative grid for the "cool dots" to work */}
            {candyBox("w-32 h-32 absolute z-0 -ml-16 mt-56 hidden lg:block")}
            {candyBox(
              "w-32 h-32 absolute -mr-16 mb-0 hidden lg:block z-0 justify-self-end self-end"
            )}
            <h2 className="mb-4 font-bold tracking-tight leading-tight text-center text-gray-900 dark:text-white text-4xl">
              Our Partners
            </h2>
            <p className="px-6 text-base sm:text-lg sm:px-14 md:px-24 lg:px-64 mb-12 text-center leading-8 text-gray-500 dark:text-gray-400">
              At Arctic Research Foundation, our ability to partner with
              like-minded institutions and agencies worldwide is crucial to our
              progress. We strive to expand these partnerships to enhance our
              impact, collaborate effectively, and multiply our contributions to
              the scientific community through shared resources and collective
              approaches.
            </p>
            <div className="grid grid-cols-2 gap-6 text-gray-500 lg:grid-cols-4 dark:text-gray-400">
              <a
                href="https://www.gov.nt.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 z-10 dark:bg-gray-100"
              >
                {/* LOGO #1 */}
                <img
                  className="h-28 object-contain"
                  src={LogoNWT}
                  alt="Government of Northwest Territories Logo"
                />
              </a>
              <a
                href="https://www.queensu.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-100"
              >
                {/* LOGO #2 */}
                <img
                  className="h-28 object-contain"
                  src={LogoQueens}
                  alt="Queen's University Logo"
                />
              </a>
              <a
                href="https://www.ubc.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-100"
              >
                {/* LOGO #3 */}
                <img
                  className="h-28 object-contain"
                  src={LogoUofBC}
                  alt="University of British Columbia Logo"
                />
              </a>
              <a
                href="https://www.ucalgary.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-100"
              >
                {/* LOGO #4 */}
                <img
                  className="h-28 object-contain"
                  src={LogoUofCalgary}
                  alt="University of Calgary Logo"
                />
              </a>
              <a
                href="https://umanitoba.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-100"
              >
                {/* LOGO #5 */}
                <img
                  className="h-28 object-contain"
                  src={LogoUofM}
                  alt="University of Manitoba Logo"
                />
              </a>
              <a
                href="https://www.dal.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-100"
              >
                {/* LOGO #6 */}
                <img
                  className="h-28 object-contain"
                  src={LogoUofDalhousie}
                  alt="Dalhousie University Logo"
                />
              </a>
              <a
                href="https://www.unb.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-100"
              >
                {/* LOGO #7 */}
                <img
                  className="h-28 object-contain"
                  src={LogoUofNB}
                  alt="University of New Brunswick Logo"
                />
              </a>
              <a
                href="https://www.uvic.ca/"
                className="flex justify-center p-6 items-center rounded-lg bg-gray-50 hover:bg-gray-100 z-10 dark:bg-gray-100"
              >
                {/* LOGO #8 */}
                <img
                  className="h-28 object-contain"
                  src={LogoUofVictoria}
                  alt="University of Victoria Logo"
                />
              </a>
            </div>
          </div>
        </section>

        {/* Contributor section */}
        <section
          className="mt-32 bg-gray-50 dark:bg-gray-800"
          ref={contributeRef}
        >
          {/* <section className="mt-32 mb-24 bg-gray-50 dark:bg-gray-800" ref={contributeRef}> */}
          <div className="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl relative lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
            <img
              draggable="false"
              src={Image}
              alt="Researcher handling equipment"
              className="rounded-lg inline-block object-cover w-full" /* max-h-96 */
              style={{ maxHeight: "29rem" }}
            />
            <div className="dark:text-gray-400">
              <h2 className="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white mt-8 lg:mt-0">
                Contribute Your Research Data
              </h2>
              <p className="mb-6 text-base sm:text-lg sm:leading-8 text-gray-500 dark:text-gray-400">
                By sharing your research data with us, you play a crucial role
                in expanding the accessibility and impact of Arctic research.
                Whether it's data on wildlife, environmental conditions, or
                indigenous knowledge, your contributions will enrich the
                database and support diverse research initiatives.
              </p>
              <div className="flow-root">
                <ul role="list" className="-mb-8">
                  <li>
                    <div className="relative pb-8">
                      <span
                        className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200 dark:bg-gray-400"
                        aria-hidden="true"
                      />
                      <div className="relative flex space-x-3">
                        <div>
                          <span className="h-8 w-8 bg-blue-700 rounded-full flex items-center justify-center ring-8 ring-gray-50 dark:ring-gray-800">
                            <p className="font-semibold text-white">1</p>
                          </span>
                        </div>
                        <div className="flex min-w-0 flex-1 justify-between space-x-4 items-center">
                          <div>
                            <p className="text-gray-500 dark:text-gray-400">
                              Create an account
                              {/* <a href="" className="font-medium text-gray-900">
                                Sign Up
                              </a> */}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="relative pb-8">
                      <span
                        className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200 dark:bg-gray-400"
                        aria-hidden="true"
                      />
                      <div className="relative flex space-x-3">
                        <div>
                          <span className="h-8 w-8 bg-blue-700 rounded-full flex items-center justify-center ring-8 ring-gray-50 dark:ring-gray-800">
                            <p className="font-semibold text-white">2</p>
                          </span>
                        </div>
                        <div className="flex min-w-0 flex-1 justify-between space-x-4 items-center">
                          <div>
                            <p className="text-gray-500 dark:text-gray-400">
                              Get verified as a contributor
                              {/* <a href="" className="font-medium text-gray-900">
                                Sign Up
                              </a> */}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="relative pb-8">
                      <div className="relative flex space-x-3">
                        <div>
                          <span className="h-8 w-8 bg-blue-700 rounded-full flex items-center justify-center ring-8 ring-gray-50 dark:ring-gray-800">
                            <p className="font-semibold text-white">3</p>
                          </span>
                        </div>
                        <div className="flex min-w-0 flex-1 justify-between space-x-4 items-center">
                          <div>
                            <p className="text-gray-500 dark:text-gray-400">
                              Submit datasets
                              {/* <a href="" className="font-medium text-gray-900">
                                Sign Up
                              </a> */}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <button
                type="button"
                className="mt-6 inline-flex items-center gap-x-2 rounded-md border-2 border-blue-700 px-3.5 py-2 text-sm font-semibold text-blue-700 shadow-sm hover:text-white hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:text-white"
                onClick={() => history.push(contributorCtaTarget)}
              >
                {contributorCtaLabel}
                <HiArrowNarrowRight
                  className="-mr-0.5 h-5 w-5"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </section>
      </main>
      <div className="pb-24 bg-white dark:bg-gray-900"></div>{" "}
      {/* Creates space between the last section and the footer. Not necessary in light mode but in dark mode you get a white space without this. */}
    </>
  );
}

export default Main;